import { Payout } from "@/interfaces/Payout";
import learnlinkAPI from "./learnlinkAPI";

export const getPayouts = async(userId: string): Promise<Payout[]> => {
  const payoutRes = await learnlinkAPI.axios.get<Payout[]>(
    `/app/payouts/${userId}`,
  );
  return payoutRes.data;
};
